<button mat-flat-button [disabled]="disabled">
	<label
		[for]="domId"
		[class.bad]="!!status"
		[class.hungry]="hasFileOver"
	>
		<div *ngIf="!status && !value" class="waiting">
			<mat-icon>file_upload</mat-icon>
			<div class="label-text">{{labelText}}</div>
			<div>{{acceptsText}}</div>
		</div>
		<div *ngIf="!status && value" class="good">
			<mat-icon>check</mat-icon><br/>
			File Selected<br/>
			<span class="ellipsis">{{value.name}}</span>
		</div>
		<div *ngIf="status==='bad-type'" class="bad bad-type">
			<mat-icon>close</mat-icon><br/>
			File is not an accepted type
		</div>
	</label>
	<input #inputFile type="file" [id]="domId" required accept="{{accept}}" [multiple]="false" (change)="fileBrowsed($event)" [disabled]="disabled"/>
</button>